import QuizItem from '../../Components/QuizItem/QuizItem'
import { Questions } from '../../questions'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  pushNewEntry,
  clearEntries,
  finished,
} from '../../Redux/Features/Quiz/quizStateSlice'
import './Quiz.css'

const Quiz = () => {
  const [section, setSection] = useState(0)
  const dispatch = useDispatch()

  const missed_entries = useSelector((state) => state.quiz.missed_entries)

  const nextSection = () => {
    dispatch(clearEntries())

    let missed_entries = []

    Questions[section].questions.forEach((element) => {
      if (
        !JSON.parse(localStorage.getItem('result')).hasOwnProperty(element.id)
      ) {
        missed_entries.push(element.id)
      }
    })

    if (missed_entries.length) {
      dispatch(pushNewEntry(missed_entries))
      return
    }

    window.scrollTo(0, 0)
    setSection((prev) => prev + 1)
  }

  const previousSection = () => {
    window.scrollTo(0, 0)
    setSection((prev) => prev - 1)
    dispatch(clearEntries())
  }

  const calculateBarProgress = () => {
    return (100 * (section + 1)) / Questions.length
  }

  const finishQuiz = () => {
    dispatch(clearEntries())

    let missed_entries = []

    Questions[section].questions.forEach((element) => {
      if (
        !JSON.parse(localStorage.getItem('result')).hasOwnProperty(element.id)
      ) {
        missed_entries.push(element.id)
      }
    })

    if (missed_entries.length) {
      dispatch(pushNewEntry(missed_entries))
      return
    }

    window.scrollTo(0, 0)
    dispatch(finished())
  }

  useEffect(() => {
    if (!localStorage.getItem('result'))
      localStorage.setItem('result', JSON.stringify({}))
  }, [])

  return (
    <div className='quiz__content mw-1340'>
      <div className='wrapper'>
        <div className='section__container'>
          <h1 className='section_name'>{Questions[section].section}</h1>
        </div>
        <div className='quiz__content__container'>
          {Questions[section].questions.map((entity) => (
            <QuizItem
              question_title={entity.prompt}
              option_a={entity.option_a}
              option_b={entity.option_b}
              option_c={entity.option_c}
              option_d={entity.option_d}
              section={section}
              id={entity.id}
              key={entity.id}
            />
          ))}
        </div>
        <div className='progress-bar' id='page_start'>
          <div
            className='fill'
            style={{ width: `${calculateBarProgress()}%` }}
          ></div>
          <div className='line'></div>
          <div className='progress-bar__info'>
            <p>Прогресс</p>
            <p>
              {section + 1}/{Questions.length} Розділ
            </p>
          </div>
        </div>
        <div>
          <p
            style={{
              color: 'red',
              display: `${missed_entries.length ? 'block' : 'none'}`,
              marginBottom: '1rem',
            }}
          >
            Будь ласка, опрацюйте усі питання розділу!
          </p>
        </div>
        <div>
          <div className='quiz__content__navigation'>
            <button
              className='quiz__content__navigation-back'
              onClick={previousSection}
              disabled={section === 0}
            >
              Повернутись
            </button>
            {section === Questions.length - 1 ? (
              <button
                className='quiz__content__navigation-next'
                onClick={finishQuiz}
              >
                Завершити тест
              </button>
            ) : (
              <button
                className='quiz__content__navigation-next'
                onClick={nextSection}
              >
                Наступний розділ
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quiz
